import { render, staticRenderFns } from "./AssessmentDetail.vue?vue&type=template&id=fde9fa3e&scoped=true"
import script from "./AssessmentDetail.vue?vue&type=script&lang=js"
export * from "./AssessmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde9fa3e",
  null
  
)

export default component.exports